// Valor de uma divergencia de recebimento — a conta que decide quanto o fornecedor deve.
//
// ⚠️ Ela existe aqui, e nao dentro do service, porque a MESMA conta e' feita duas vezes: o
// backend grava `valor_faltante` (e a CP de credito) e a tela mostra a previa antes de gravar.
// As duas nasceram separadas e as duas estavam erradas do mesmo jeito ([[DA-559]]).
//
// O DEFEITO que originou isto (17/08/2026): `qtd_faltante` e' digitado na unidade de ESTOQUE
// (a validacao usa `qtd_real` como teto e a baixa faz `estoque_atual - qtd_faltante`), mas
// `valor_unitario` e' o preco da unidade da NOTA — o rolo, a caixa, o fardo. Multiplicar um
// pelo outro mistura as duas: num cabo de 1 CD = 1200 m, `1200 * 2379,39` dava
// **R$ 2.855.268,00** no lugar de R$ 2.379,39; e informar `1` pra acertar o dinheiro tirava
// 1 metro de 1200. Nao havia valor certo pros dois.
//
// Medido em producao no dia: 95 de 431 itens de nota tem `qtd_real <> quantidade` — sao os
// cabos e canos, comprados em rolo e vendidos em metro. O pior daria R$ 3.076.928,00.
//
// Aqui o preco desce pra unidade de estoque ANTES de multiplicar. Sem conversao
// (`qtd_real` = `quantidade`) o resultado e' identico ao que era, de proposito: o conserto
// nao pode mexer no numero dos itens que ja estavam certos.
export function calcularValorFaltante(args: {
  /** Quanto faltou/voltou, na unidade de ESTOQUE (ex.: 1200 metros). */
  qtdFaltante: number;
  /** Quantidade como a NOTA traz (ex.: 1 rolo). */
  quantidadeNota: number;
  /** Quantidade na unidade de ESTOQUE; `null` em nota antiga, que nao converte. */
  qtdReal: number | null;
  /** Preco da unidade da NOTA (ex.: R$ 2.379,39 pelo rolo inteiro). */
  valorUnitario: number;
}): number {
  const qtdEstoque = args.qtdReal ?? args.quantidadeNota;
  const valorLinha = Math.round(args.quantidadeNota * args.valorUnitario * 100) / 100;
  const precoPorUnidadeEstoque = qtdEstoque > 0 ? valorLinha / qtdEstoque : args.valorUnitario;
  return Math.round(args.qtdFaltante * precoPorUnidadeEstoque * 100) / 100;
}

/**
 * `true` quando a mercadoria e' comprada numa embalagem e controlada noutra unidade — o caso
 * em que a tela precisa dizer em QUE unidade o operador esta digitando, senao ele le "1200"
 * ao lado de uma nota que diz "1 CD" e nao sabe qual dos dois o campo espera.
 */
export function temConversaoDeUnidade(quantidadeNota: number, qtdReal: number | null): boolean {
  return qtdReal !== null && qtdReal !== quantidadeNota;
}
